import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "9d8kgobr",
  dataset: "production",
});
